import { Team } from '../../entities/Team'
import { httpClient } from '../http/httpClient'

export const getTeamById = async (teamId: string) => {
  const { data } = await httpClient.get<Team>(`/team/${teamId}`)

  return data
}
